import { render, staticRenderFns } from "./ImprintPrivacyPolicy.vue?vue&type=template&id=84f41152&scoped=true&"
import script from "./ImprintPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ImprintPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f41152",
  null
  
)

export default component.exports